import React, { FC } from 'react';
import classnames from 'classnames';
import { Avatar } from '@src/components/Avatar';
import { TalentListItemProps } from './props';
import './styles.scss';

export const TalentListItem: FC<TalentListItemProps> = ({
  avatarColor,
  avatarUrl,
  expectedSalary,
  locationNames,
  message,
  nameInitials,
  title,
  timeStamp,
  onClick,
  isContentHidden,
  isActive,
}) => {
  return (
    <div
      className={classnames(
        'talent-pipeline-sidebar-list-item',
        isActive && 'talent-pipeline-sidebar-list-item--active',
      )}
      onClick={onClick}
    >
      <div className="talent-pipeline-sidebar-list-item__avatar-wrapper">
        <Avatar
          avatarColor={avatarColor}
          className={classnames(
            'talent-pipeline-sidebar-list-item__avatar',
            isContentHidden && 'talent-pipeline-sidebar-list-item__avatar--blur',
          )}
          initials={nameInitials}
          size="x-large"
          source={avatarUrl}
        />
      </div>

      <div className="talent-pipeline-sidebar-list-item__info">
        <div className="talent-pipeline-sidebar-list-item__info-top">
          <div className="talent-pipeline-sidebar-list-item__info-title-wrapper">
            <div className="talent-pipeline-sidebar-list-item__info-title">{title}</div>
          </div>

          <div className="talent-pipeline-sidebar-list-item__info-timestamp">{timeStamp}</div>
        </div>

        <div className="talent-pipeline-sidebar-list-item__info-subtitle">
          {locationNames.join(', ')} • {expectedSalary}
        </div>

        <div className="talent-pipeline-sidebar-list-item__info-label">I'm looking for</div>

        <div className="talent-pipeline-sidebar-list-item__info-text">{message}</div>
      </div>
    </div>
  );
};
